import { render, staticRenderFns } from "./Table_news_ipos.vue?vue&type=template&id=e49e6182&scoped=true&"
import script from "./Table_news_ipos.vue?vue&type=script&lang=js&"
export * from "./Table_news_ipos.vue?vue&type=script&lang=js&"
import style0 from "./Table_news_ipos.vue?vue&type=style&index=0&id=e49e6182&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49e6182",
  null
  
)

export default component.exports